/// <reference path="../../../../typings/index.d.ts" />
module Meevo {

    export function meevoMenuPositionFilter($filter: angular.IFilterService, $translate: angular.translate.ITranslateService): any {
        const filter = (array: any, date: any) => {

            let filterOrderBy = $filter('orderBy') as angular.IFilterOrderBy;
            var getTranslatedValue = function(obj: IMenuItem) {
                return $translate.instant(obj.contentKey);
            }
            var orderedByAsc = filterOrderBy(array, getTranslatedValue)
            var returnArray = [];
            angular.forEach(orderedByAsc, (item: IMenuItem) => {
                item.position == 1 ? returnArray.unshift(item) : returnArray.push(item);
            })

            return returnArray;
        };
        return filter;
    }

    meevoMenuPositionFilter.$inject = ['$filter', '$translate'];

    angular.module("meevo")
        .filter("meevoMenuPosition", meevoMenuPositionFilter);
}